<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          Date Wise Cash Expense Report : {{ this.month }} {{ year }}
        </h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table
          datatable
          class="row-border hover tablelist"
          *ngIf="expenseArray.length > 0"
        >
          <thead>
            <tr>
              <td>Date</td>
              <td>Company Name</td>
              <td>Supervisor Name</td>
              <td>LR Number</td>
              <td>Vehicle Number</td>
              <td>Expense Description</td>
              <td>Expense Amount</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let expense of expenseArray">
              <td>{{ expense.date | date : "dd/MM/yyyy" }}</td>
              <td>{{ expense.companyName }}</td>
              <td>{{ expense.supervisorName }}</td>
              <td>{{ expense.LRNumber }}</td>
              <td>{{ expense.vehicleNumber }}</td>
              <td>{{ expense.expenseDescription }}</td>
              <td>{{ expense.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
